<!-- Template -->

<template>
    <Layout
        :path="path"
        :hospital="hospital"
        :hospitals="hospitals"
        :section="'tickets'"
        :loading="loading"
    >
        <TicketsHeader />
        <TicketsContent :hospital="hospital" :tickets="tickets" :hasTickets="hasTickets" />
    </Layout>
</template>

<!-- Script -->

<script>
    import "@/prototypes/array";

    import { HospitalService } from "@/services/hospital-service";

    import Layout from "@/layouts/Default";

    import TicketsHeader from "@/components/Tickets/Header";
    import TicketsContent from "@/components/Tickets/Content";

    export default {
        name: "Tickets",

        components: {
            Layout,
            TicketsHeader,
            TicketsContent
        },

        data() {
            return {
                params: {
                    hospital: null
                },
                hospitals: [],
                hospital: null,
                loading: true,
                path: [],
                tickets: [],
                hasTickets: false
            };
        },

        watch: {
            $route(to) {
                this.params.hospital = +to.params.hospital;
                this.update();
            },

            hospital: {
                deep: true,
                immediate: true,
                handler(value) {
                    if (value) {
                        this.hospital = value;
                        this.hasTickets = this.hospital.supportTicketsCount;
                        this.tickets = this.hospital.supportTickets;
                        for (var i = 0; i < this.hospitals.length; i++) {
                            if (this.hospitals[i].id == this.hospital.id) {
                                this.hospitals[i] = this.hospital;
                            }
                        }
                        this.update();
                    }
                }
            }
        },

        created() {
            this.params.hospital = +this.$route.params.hospital;
            this.hospitalService = new HospitalService(this.$api, this.$store);
        },

        async mounted() {
            this.hospitals = await this.hospitalService.list();
            this.update();
        },

        methods: {
            update() {
                var self = this;
                var temp = this.hospitals.filter(function(h) {
                    return h.id == self.$route.params.hospital;
                });
                this.hospital = temp[0];
                this.hasTickets = this.hospital.supportTicketsCount;
                this.tickets = this.hospital.supportTickets;

                this.loading = false;

                this.path = [];
                this.path.push(
                    {
                        name: this.hospital.locationName,
                        last: false,
                        path: "/hospitals/" + this.params.hospital
                    },
                    {
                        name: "Open Tickets",
                        last: true,
                        path: "/hospitals/" + this.params.hospital + "/tickets"
                    }
                );
            }
        }
    };
</script>

